var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Sedes","company":_vm.comdes,"addMethod":"itemsSedes","closeBaseWindow":"addSedes","titleAddMethod":"Agregar Sede","itemStoreName":"itemsSedes","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Sede',
    edicion: 'Editar Sede',
    url: `/transjuma/Sede/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }